import { motion } from 'framer-motion';
import { ArrowRight, Calendar } from 'lucide-react';

export const Contact = () => {
    return (
        <section id="contact" className="py-20 md:py-28 bg-[#2C2C2C]" data-testid="contact-section">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-center max-w-2xl mx-auto"
                >
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#34A853]/20 mb-6">
                        <Calendar size={28} className="text-[#34A853]" />
                    </div>
                    
                    <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
                        Ready to Save Time Every Week?
                    </h2>
                    
                    <p className="text-white/70 text-lg leading-relaxed mb-8">
                        Let's have a quick chat about your spreadsheets. I'll show you what's possible -
                        and you'll probably wonder why you didn't find me sooner.
                    </p>

                    <a
                        href="https://tidycal.com/parth/discovery"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-2 bg-[#34A853] hover:bg-[#2E9648] text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg hover:shadow-xl transition-all duration-200 hover:-translate-y-0.5"
                        data-testid="book-call-button"
                    >
                        Book Your Free Call
                        <ArrowRight size={20} />
                    </a>

                    <p className="mt-6 text-white/50 text-sm">
                        30 minutes. No commitment. Let's see if I can help.
                    </p>
                </motion.div>
            </div>
        </section>
    );
};
